import { ApiClientError } from '@/shared/lib/api';

interface AuthErrorFallbacks {
  /** Localized "no connection" copy (t('common.errors.network')). */
  network: string;
  /** Localized generic failure copy (t('common.errors.generic')). */
  generic: string;
}

/**
 * User-facing message for an auth-form failure.
 *
 * API-composed messages pass through verbatim (API-driven messages rule).
 * Everything the client composed itself never reaches the user raw:
 * transport failures (status 0) used to surface as the browser's own
 * "Failed to fetch" / "Load failed", and decode/shape errors as internal
 * English strings — in all 24 locales. Those map to localized fallbacks.
 */
export function resolveAuthErrorMessage(
  error: unknown,
  fallbacks: AuthErrorFallbacks
): string {
  if (error instanceof ApiClientError) {
    if (error.status === 0) {
      return fallbacks.network;
    }
    return error.getFirstError() || fallbacks.generic;
  }
  return fallbacks.generic;
}
